import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'account.orderHistory.detail.title',
    defaultMessage: 'Order History',
  },
  subTitle: {
    id: 'account.orderHistory.detail.subTitle',
    defaultMessage: 'Order Reference',
  },
  supportButton: {
    id: 'account.orderHistory.detail.supportButton',
    defaultMessage: 'Get support',
  },
  backButton: {
    id: 'account.orderHistory.detail.back',
    defaultMessage: 'Back to my orders',
  },
});
